<template>
  <div class="row">
    <div class="col-12">
      <div class="alert text-center" :class="[alertType]">
          <span v-html="alertText"></span>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "Alert",

  props: {
    alertType: String,
    alertText: String,
  }
}
</script>

<style scoped>

</style>